import { css } from 'styled-components';
import colors from '../../style/colors';
import { sizes as textSizes } from '../text/style';

const variants = {
  gray600: css`
    color: ${colors.gray600};
  `,
  inherit: css`
    color: inherit;
  `,
  white: css`
    color: ${colors.white};
  `,
  action: css`
    color: ${props => props.theme.actionColor};
  `,
  gray900: css`
    color: ${colors.gray900};
  `,
};

const sizes = {
  ...textSizes,
  inherit: css`
    font-size: inherit;
  `,
};

export const decorations = {
  none: css`
    text-decoration: none;

    &:hover {
      text-decoration: none;
    }
  `,
  underline: css`
    text-decoration: underline;

    &:hover {
      text-decoration: underline;
    }
  `,
  'underline-hover': css`
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  `,
};

export { sizes, variants };
